import { render } from "./LoadingComponent.vue?vue&type=template&id=27e84f67&scoped=true"
import script from "./LoadingComponent.vue?vue&type=script&lang=js"
export * from "./LoadingComponent.vue?vue&type=script&lang=js"

import "./LoadingComponent.vue?vue&type=style&index=0&id=27e84f67&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Murilo\\Documents\\app-construp-cms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e84f67"]])

export default __exports__